
import { types, actions } from './requests'
export const GETFAMILY_TYPES = {
    ...types('GETFAMILY'),
}
export const GETFAMILY_ACTIONS = {
    ...actions('GETFAMILY'),
}